import {FormattedMessage} from 'react-intl';
import {DropArea} from '../../base-components/StudioDropArea';
import {FileExplorer} from '../TestDeployView/FileExplorer';
import {Field, FieldProps} from 'formik';
import {Box} from '@material-ui/core';
import React, {useState} from 'react';
import {InferenceAppConfigFields} from './InferenceAppConfigFields';
import {InferenceAppFieldsBaseProps, InferenceAppForm} from './InferenceAppTypes';
import {ACCEPTED_FILE_TYPES} from '../../config/constants';

export type BatchConfigPanelProps = InferenceAppFieldsBaseProps & {};

export const BatchConfigPanel = ({
  application,
  inProgress,
  values,
  spa,
  projectPostProcessors,
  viewMode,
  handlePostProcessorChange,
  onCheckboxChanged,
  setReady,
  gspList,
}: BatchConfigPanelProps) => {
  const [appConfigFieldsReady, setAppConfigFieldsReady] = useState(false);

  const handleImageAppend = (existing: File[], newFiles: File[]) => {
    const merged = [...existing];
    newFiles.forEach(newFile => {
      if (!merged.find(file => file.name === newFile.name)) {
        merged.push(newFile);
      }
    });
    return merged;
  };

  const checkReadiness = () => {
    setReady(appConfigFieldsReady && !!values.images && values.images.length > 0);
  };

  const updateAppConfigFieldsReadiness = (value: boolean) => {
    setAppConfigFieldsReady(value);
    checkReadiness();
  };

  return (
    <div className="inference-app__fields">
      <InferenceAppConfigFields
        application={application}
        inProgress={inProgress}
        allowAPIExposure={application.runtimeType !== 'ONNX_RUNTIME_WEB'}
        values={values}
        spa={spa}
        postProcessorRequired={true}
        projectPostProcessors={projectPostProcessors}
        viewMode={viewMode}
        handlePostProcessorChange={handlePostProcessorChange}
        onCheckboxChanged={onCheckboxChanged}
        setReady={updateAppConfigFieldsReadiness}
        gspList={gspList}
      />
      {values.exposeInferencePage && (
        <Field name="images">
          {({field, form}: FieldProps<InferenceAppForm['images']>) => {
            const setValue = (value: File[] | null) =>
              form.setFieldValue('images', value);
            return (
              <div>
                <div className="inference-app__label">
                  <FormattedMessage id="inferenceApp.images" />
                </div>
                <DropArea
                  onChange={files => {
                    setValue(handleImageAppend(values.images, files));
                    checkReadiness();
                  }}
                  accept={ACCEPTED_FILE_TYPES.join(',')}
                  disabled={inProgress}
                />
                <Box>
                  <FileExplorer
                    files={field.value || []}
                    onDelete={(item, index) => {
                      const updated = [...field.value];
                      updated.splice(index, 1);
                      setValue(updated);
                    }}
                    onClear={() => setValue([])}
                    size="small"
                    icon={inProgress ? 'check' : 'delete'}
                  />
                </Box>
              </div>
            );
          }}
        </Field>
      )}
    </div>
  );
};
